<template>
  <div>
    <Autocomplete :label="option.name.toUpperCase()"
                  :options="items"
                  static
                  search-on-focus
                  ref="autocomplete"
                  :selected="selected"
                  @change="onAutocompleteChange">
      <template v-slot:selected-items>
        <div class="mt-4">
          <div v-for="(item, index) in selected"
               :key="`${item.id}_${version}`">
            <div class="flex flex-row gap-4 items-center">
              <button class="flex-shrink hover:text-red-600"
                      type="button"
                      title="Remove attribute"
                      @click="$refs.autocomplete.removeItem(item.id)">
                <TrashIcon class="w-4 h-4" />
              </button>
              <div class="w-2/6">
                {{ getValueName(item.id) }}
              </div>
              <div class="flex-1" v-if="option.has_image">
                <FormInput :show-label="false"
                           placeholder="Image name or URL"
                           v-model="selected[index].image"
                           class=""/>
              </div>
            </div>

            <p v-if="getError(item.id)" class="mt-2 text-sm text-red-600">{{ getError(item.id) }}</p>
          </div>
        </div>
      </template>
    </Autocomplete>
  </div>
</template>

<script>
import Autocomplete from '@/components/form-autocomplete'
import FormComponent from '@/pages/form-component'
import { TrashIcon } from '@heroicons/vue/outline'

export default {
  mixins: [
    FormComponent,
  ],

  components: {
    Autocomplete,
    TrashIcon,
  },

  props: {
    option: Object,
    modelValue: Array,
    errors: Object,
  },
  data() {
    const selected = this.modelValue || []

    return {
      selected,
      version: 1,
    }
  },

  emits: [
    'update:modelValue',
  ],

  methods: {
    onAutocompleteChange(selectedIds) {
      this.selected = selectedIds.map(id => {
        return this.selected.find(item => item.id == id)
          || { id, image: null }
      })

      this.$emit('update:modelValue', this.selected)
    },

    getValueName(id) {
      return this.items.find(item => item.id == id)?.name
    },

    getError(valueId) {
      const regex = new RegExp(`^options\\.${valueId}\\.`)

      const key = Object.keys(this.errors)
        .find(key => regex.test(key))

      return key && this.errors[key]
    }
  },

  computed: {
    items() {
      return this.option.values.map(item => ({
        id: item.value,
        name: item.label,
      }))
    },

    error() {
      if (! this.errors) {
        return
      }

      const ids = this.items.map(({ id }) => id)
        .join('|')

      const regex = new RegExp(`^options\\.${ids}\\.`)
      const key = Object.keys(this.errors)
        .find(key => regex.test(key))

      return this.errors[key]
    },
  }
}
</script>
